import CashDesk from '@/views/CashDesk/CashDesk'
import CashMovement from '@/views/CashMovement'
import SearchIdVenta from '@/components/CashDesk/Detail/SearchIdVenta'
import CashDeskMock from '@/components/CashDesk/Detail/CashDeskMock'
import SaleDetail from '@/components/CashDesk/Detail/SaleDetails'
import CustomerForm from '@/views/Client/CustomerForm'
import PaymentSummaries from '@/views/PaymentSummaries/PaymentSummaries'
import CreditNote from '@/views/CreditNote/CreditNote'
import CloseCash from '@/views/CloseCash/Close.vue'
import DTEList from '@/views/DTEList/DTEList'
import Salir from '@/views/Auth/Salir'
import CustomerPaymentMenuRoutes from './customerPayment/CustomerPaymentMenuRoutes'
import PaymentVerifyList from '@/views/PaymentVerify/PaymentVerifyList'
import BillBatchList from '@/views/OrdererToBill/OrdererBatchListToBill'
import BillBatchDetails from '@/views/OrdererToBill/partials/BatchDetailsToBill'
import Rendicion from '../views/RendicionNew/Rendicion.vue'
import Reports from '../views/Reports/Reports.vue'
import SetCounters from '../views/Counters/SetCounters.vue'
import TbkView from '../views/Tbk/TbkView.vue'
import RetireBankCheck from '../views/RetireBankCheck/RetireBankCheck.vue'
import PaymentReport from '../views/PaymentReport/PaymentReport.vue'

export default [
    {
        path: '/',
        name: 'CashDesk',
        component: CashDesk,
    },

    {
        // después tengo que borrar esto
        path: '/search_venta',
        name: 'SearchIdVenta',
        component: SearchIdVenta,
    },
    {
        path: '/cash_desk_mock',
        name: 'CashDeskMock',
        component: CashDeskMock,
    },
    {
        path: '/detail',
        name: 'Detail',
        component: SaleDetail,
    },
    {
        path: '/movement',
        name: 'cash-movement',
        component: CashMovement,
    },
    {
        path: '/nuevo_cliente',
        name: 'newCustomer',
        component: CustomerForm,
    },
    {
        path: '/arqueo',
        name: 'paymentSummaries',
        component: PaymentSummaries,
    },
    {
        path: '/nota_credito',
        name: 'CreditNote',
        component: CreditNote,
    },
    {
        path: '/close',
        name: 'closeCash',
        component: CloseCash,
    },
    {
        path: '/reimprimir',
        name: 'reimprimir',
        component: DTEList,
    },
    {
        path: '/salir',
        name: 'salir',
        component: Salir,
    },
    ...CustomerPaymentMenuRoutes,
    {
        path: '/customer_payment_verify',
        name: 'customerPaymentVerify',
        component: PaymentVerifyList,
    },
    {
        path: '/bill_batch_list',
        component: BillBatchList,
        // Children doesn't work
        // children: [
        //     {
        //         path: ':id',
        //         name: 'billBatchDetail',
        //         component: BillBatchDetails,
        //     },
        // ],
    },
    {
        path: '/bill_batch_list/:id',
        name: 'billBatchDetail',
        component: BillBatchDetails,
    },
    {
        path: '/rendicion',
        name: 'rendicion',
        component: Rendicion,
    },
    {
        path: '/reports',
        name: 'reports',
        component: Reports,
    },
    {
        path: '/payment_report',
        name: 'paymentReport',
        component: PaymentReport,
    },
    {
        path: '/correlativos',
        name: 'counters',
        component: SetCounters,
    },
    {
        path: '/transbank',
        name: 'transbank',
        component: TbkView,
    },
    {
        path: '/retire_bank_check',
        name: 'retireBank',
        component: RetireBankCheck,
    },
]
